import Constants from 'expo-constants';

export default function getDebuggerHost() {
  const uri = Constants.manifest2?.extra?.expoClient?.hostUri
    ?.split(':')
    .shift();

  if (Constants.experienceUrl) {
    return new URL(Constants.experienceUrl).hostname;
  }

  const hostname = uri || 'localhost';

  return hostname;
}
